import * as React from 'react'

export const HttpStatusContext = React.createContext<{
  setStatus: (value: number) => void
  status: number | undefined
} | null>(null)
